<template>
  <div class="refunedContainer">
    <van-tabs v-model="active" animated @change="onChange(active)">
      <van-tab
        v-for="index in refundList"
        :key="index.id"
        :title="index.title"
        :badge="index.num > 0 ? index.num : ''"
      >
      </van-tab>
    </van-tabs>
    <div class="noOrders" v-if="orderList.length == 0">
      <div class="imageEmptyStock">
        <img src="../../../assets/images/orderEmpty.png" alt />
      </div>
      <div v-if="!firstLoading">你还没有订单哦...</div>
      <van-loading v-else type="spinner" />
    </div>
    <div
      :class="AgentIsShow == true ? 'scrollAgent' : 'scroll'"
      v-if="orderList.length > 0"
    >
      <!-- <van-pull-refresh
        v-model="refreshing"
        style="height: calc(100% - 24.2vw); overflow: auto"
      > -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="到底啦~"
        @load="onLoad"
        :immediate-check="false"
        class="cardList"
      >
        <!-- <van-panel
            :title="'订单编号：' + order.orderId"
            :status="getChineseStatus(order.orderStatus)"
            style="border-bottom: 5px solid #f4f4f4"
          > -->
        <van-panel
          v-for="order in orderList"
          :key="order.id"
          style="border-bottom: 5px solid #f7f7f7"
        >
          <template slot="header">
            <div class="orderBottom">
              <div class="flex-between">
                <div class="orderHeaderTopBetween">
                  <div class="orderIcon" v-if="order.orderClass == 1">
                    <svg class="orderIcon" aria-hidden="true">
                      <use xlink:href="#icon-daimaitubiao"></use>
                    </svg>
                  </div>
                  {{ "订单编号：" + order.orderId }}
                </div>
                <div class="orderHeaderTop panelStatus">
                  {{ getChineseStatus(order.orderRefundStatus) }}
                </div>
              </div>
            </div>
          </template>
          <div>
            <div
              v-for="(item, index) in order.commonOrderItems"
              :key="index"
              class="cardItem"
            >
              <van-card
                :num="item.quantity"
                :desc="item.itemSpecs"
                :title="item.itemName"
                :thumb="item.picture"
                class="card_shop"
              ></van-card>
            </div>
            <van-panel v-if="order.giftOrderItems.length !== 0" :border="false">
              <template slot="header">
                <div class="flex-between orderBottom">
                  <div
                    class="panelHeader red"
                    v-if="order.giftOrderItems[0].goodsType == 1"
                  >
                    赠品
                  </div>
                  <div
                    class="panelHeaderType"
                    v-if="order.giftOrderItems[0].goodsType == 3"
                  >
                    赠品
                  </div>
                </div>
              </template>
              <van-card
                v-for="item in order.giftOrderItems"
                :key="item.goodsCode"
                :num="item.goodsQuantity"
                :title="item.goodsName"
                :desc="item.goodsSkuSpecificationNames"
                :thumb="item.goodsPicture"
                class="shopCard"
              />
            </van-panel>
          </div>
          <div slot="footer">
            <div class="orderlist_foot flex-between">
              <div class="flex">
                <div class="ActualAmount">
                  实付金额:
                  <span style="color: #ee0a24">
                    ￥{{ formatPrice(order.amount / 100) }}
                  </span>
                </div>
                <div class="order_sum" v-if="order.giftOrderItems.length !== 0">
                  共{{
                    [...order.commonOrderItems, ...order.giftOrderItems]
                      .map((val) => val.quantity)
                      .reduce((prev, curr) => {
                        return prev + curr;
                      }, 0)
                  }}件
                </div>
                <div class="order_sum" v-else>
                  共{{
                    order.commonOrderItems.reduce((prev, curr) => {
                      return prev + curr.quantity;
                    }, 0)
                  }}件
                </div>
              </div>
              <div class="order_sum" style="font-size: 12px">
                {{ order.createTime.slice(0, 16) }}
              </div>
            </div>
            <div class="orderlist_message" v-if="order.orderRefundStatus == 4">
              <div>驳回原因：</div>
              <div class="describe">{{ order.message }}</div>
            </div>

            <!-- <button
                class="cancel"
                @click="onCancel(order.orderId)"
                v-if="order.orderStatus == 'submitted'"
              >
                取消
              </button> -->
          </div>
        </van-panel>
      </van-list>
      <!-- </van-pull-refresh> -->
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Tab,
  Tabs,
  Card,
  Toast,
  // PullRefresh,
  Panel,
  List,
  NavBar,
  Loading,
  Badge,
  Dialog,
  Overlay,
} from "vant";
import { mapGetters } from "vuex";
import loading from "../../components/loading/loading";
import service from "../../api/order/index";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Card.name]: Card,
    [Toast.name]: Toast,
    [Panel.name]: Panel,
    [List.name]: List,
    // [PullRefresh.name]: PullRefresh,
    [NavBar.name]: NavBar,
    [Loading.name]: Loading,
    [Badge.name]: Badge,
    [Dialog.Component.name]: Dialog.Component,
    [Overlay.name]: Overlay,
    loading,
  },
  data() {
    return {
      firstLoading: false,
      isLoading: true, //loading状态
      active: 0,
      orderStatusId: "1,2",
      refundList: [
        { name: "1,2", title: "处理中" },
        { name: "3,4", title: "退款记录" },
      ],
      orderList: [],
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
    };
  },
  computed: {
    ...mapGetters(["agentShow"]),
    AgentIsShow() {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    formatPrice(price) {
      if (price >= 1) {
        return price.toFixed(2);
      } else {
        return price;
      }
    },
    onChange(active) {
      this.isLoading = true;
      if (active == 0) {
        this.orderStatusId = "1,2";
      }
      if (active == 1) {
        this.orderStatusId = "3,4";
      }
      this.orderList = [];
      this.page = 1;
      this.firstLoading = true;
      this.loading = true;
      this.getList()
        .then((orderList) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          this.orderList = orderList.refundOrderListDtos;
          this.firstLoading = false;
          this.loading = false;
          this.finished = false;
          if (orderList.count <= this.orderList.length) {
            this.finished = true;
          }
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    getChineseStatus(orderStatusText) {
      switch (orderStatusText) {
        case 3:
          return "已退款";
        case 4:
          return "已驳回";
        default:
          break;
      }
    },
    init() {
      this.page = 1;
      this.firstLoading = true;
      this.loading = false;
      this.finished = false;
      this.getList()
        .then((orderList) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          this.orderList = orderList.refundOrderListDtos;

          this.firstLoading = false;
          if (orderList.count <= this.orderList.length) {
            this.finished = true;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    getList() {
      return new Promise((resolve, reject) => {
        console.log(this.orderStatusId);
        var dataStr = this.orderStatusId;
        var dataStrArr = dataStr.split(",");
        var dataIntArr = [];
        if (this.orderStatusId.length !== 0 && this.orderStatusId !== "") {
          dataStrArr.forEach(function (data, index, arr) {
            dataIntArr.push(parseInt(data));
          });
        }
        console.log(dataIntArr, 494);
        service
          .refundlist(dataIntArr, this.page, this.pageSize)
          .then((response) => {
            response.data.refundOrderListDtos.map((order) => {
              order.giftOrderItems.map((i) => {
                i.quantity = i.goodsQuantity;
              });
            });
            resolve(response.data);
          })
          .catch((error) => {
            reject();
          });
      });
    },
    onLoad() {
      this.page++;
      this.getList().then((orderList) => {
        this.isLoading = false;
        this.orderList = this.orderList.concat(orderList.refundOrderListDtos);
        this.loading = false;
        this.finished = false;
        if (orderList.count <= this.orderList.length) {
          this.finished = true;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";

.refunedContainer {
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  //
  position: fixed;
  height: calc(100% - 0.7vw);
  background: #f8f8f8;

  // min-height: 100vh;
  // .scroll{
  //   margin-bottom: 50px;
  // }
  .scrollAgent {
    margin-bottom: 13vw;
  }

  @{deep}.van-tabs--line .van-tabs__wrap {
    height: 9.73333vw;
    padding: 2vw 0;
    background: #fff;
  }

  @{deep}.van-tab:nth-of-type(1) {
    border-right: 1px solid #c1c1c1;
  }

  @{deep}.van-tabs__content--animated {
    height: 100%;
  }

  @{deep}.van-tab__pane,
  @{deep}.van-tab__pane-wrapper {
    height: 100%;
  }

  .van-cell__title {
    flex: none;
    color: #92909a;
  }

  .van-card__header {
    padding: 1vh 0;
  }

  .van-card__bottom {
    line-height: 8.33333vw;
  }

  .van-card__num {
    float: left;
  }

  .orderBottom {
    height: 42px;
    font-size: 13px;
    display: flex;
    // line-height: 42px;
  }

  .orderlist_foot {
    display: flex;
    flex: 1;
    height: 4.6vh;
    font-size: 14px;
    align-items: center;
    flex-wrap: wrap;
  }

  .orderlist_message {
    display: flex;
    align-items: center;
    height: 45px;
    background: #f7f7f7;
    text-indent: 10px;
    font-size: 12px;
    margin-top: 5px;
  }

  .orderHeaderTopBetween {
    display: flex;
    align-items: center;
  }

  //   .list_footLeft{
  //       display: flex;
  //   }
  .ActualAmount {
    min-width: 30vw;
    padding-right: 5px;
  }
  .panelHeaderType {
    color: rgba(51, 51, 51, 1);
  }
}

.van-panel__footer {
  padding: 3.13333vw 2vw;
}
</style>
